import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.85355 3.85355C6.04882 3.65829 6.04882 3.34171 5.85355 3.14645C5.65829 2.95118 5.34171 2.95118 5.14645 3.14645L2.14645 6.14645C1.95118 6.34171 1.95118 6.65829 2.14645 6.85355L5.14645 9.85355C5.34171 10.0488 5.65829 10.0488 5.85355 9.85355C6.04882 9.65829 6.04882 9.34171 5.85355 9.14645L3.70711 7L10.5 7C10.7761 7 11 6.77614 11 6.5C11 6.22386 10.7761 6 10.5 6L3.70711 6L5.85355 3.85355Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.13807 4.13807C7.39842 3.87772 7.39842 3.45561 7.13807 3.19526C6.87772 2.93491 6.45561 2.93491 6.19526 3.19526L2.19526 7.19526C1.93491 7.45561 1.93491 7.87772 2.19526 8.13807L6.19526 12.1381C6.45561 12.3984 6.87772 12.3984 7.13807 12.1381C7.39842 11.8777 7.39842 11.4556 7.13807 11.1953L4.27614 8.33333L13.3333 8.33333C13.7015 8.33333 14 8.03486 14 7.66667C14 7.29848 13.7015 7 13.3333 7L4.27614 7L7.13807 4.13807Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.42259 5.42259C9.74803 5.09715 9.74803 4.56951 9.42259 4.24408C9.09715 3.91864 8.56951 3.91864 8.24408 4.24408L3.24408 9.24408C2.91864 9.56952 2.91864 10.0972 3.24408 10.4226L8.24408 15.4226C8.56951 15.748 9.09715 15.748 9.42259 15.4226C9.74803 15.0972 9.74803 14.5695 9.42259 14.2441L5.84518 10.6667L17.1667 10.6667C17.6269 10.6667 18 10.2936 18 9.83333C18 9.3731 17.6269 9 17.1667 9L5.84518 9L9.42259 5.42259Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.14645 3.14645C5.34171 2.95118 5.65822 2.95118 5.85348 3.14645C6.04874 3.34171 6.04874 3.65822 5.85348 3.85348L3.70699 5.99996H10.5C10.7761 5.99996 11 6.22382 11 6.49996C11 6.7761 10.7761 6.99996 10.5 6.99996H3.70699L5.85348 9.14645L5.88766 9.18453C6.04783 9.38092 6.03654 9.67042 5.85348 9.85348C5.67042 10.0365 5.38092 10.0478 5.18453 9.88766L5.14645 9.85348L2.14645 6.85348C1.95118 6.65822 1.95118 6.34171 2.14645 6.14645L5.14645 3.14645Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.19526 3.19526C6.45561 2.93491 6.87762 2.93491 7.13797 3.19526C7.39832 3.45561 7.39832 3.87762 7.13797 4.13797L4.27599 6.99995H13.3333C13.7015 6.99995 13.9999 7.29843 13.9999 7.66662C13.9999 8.03481 13.7015 8.33328 13.3333 8.33328H4.27599L7.13797 11.1953L7.18354 11.246C7.39711 11.5079 7.38205 11.8939 7.13797 12.138C6.89389 12.382 6.50789 12.3971 6.24604 12.1835L6.19526 12.138L2.19526 8.13797C1.93491 7.87762 1.93491 7.45561 2.19526 7.19526L6.19526 3.19526Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.24408 4.24408C8.56951 3.91864 9.09703 3.91864 9.42246 4.24408C9.7479 4.56951 9.7479 5.09703 9.42246 5.42246L5.84499 8.99994H17.1666C17.6268 8.99994 17.9999 9.37303 17.9999 9.83327C17.9999 10.2935 17.6268 10.6666 17.1666 10.6666H5.84499L9.42246 14.2441L9.47943 14.3076C9.74639 14.6349 9.72756 15.1174 9.42246 15.4225C9.11737 15.7276 8.63487 15.7464 8.30755 15.4794L8.24408 15.4225L3.24408 10.4225C2.91864 10.097 2.91864 9.56952 3.24408 9.24408L8.24408 4.24408Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconArrowNarrowLeft: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"arrow-narrow-left"} {...props} />
);
